import initialState from './initialState'
import {FETCH_STATES, RECEIVE_STATES} from '../actions/actionTypes'

export default function states(state = initialState.states, action) {
	let newState
	switch (action.type) {
	case FETCH_STATES:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_STATES:
		newState = action.states
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/states.js